export const locale = {
  lang: 'en',
  data: {
    MENU: {
      DASHBOARD: {
        COLLAPSIBLE: 'Dashboards',
      },
      ESP: {
        COLLAPSIBLE: 'Espace marchand',
      },
      Wallet: {
        SECTION: 'Wallet',
        AW: {
          COLLAPSIBLE: 'Add funds to my wallet',
          Carte: 'Through card payment',
          Espece: 'Through payment or transfer',
          RV: 'Through a reseller',
        },
        TA: {
          COLLAPSIBLE: 'Money Transfer',
          ws: 'Wallet SPW',
          cb: 'Bank account'
        },
        MW: {
          COLLAPSIBLE: "Mes wallets",
        }
      },
      SERVICE: {
        SECTION: 'Services',
        RT: {
          COLLAPSIBLE: 'Mobile Recharge',
          TD: 'Direct Transfer',
          CR: 'Charging board',
        },
        DS: {
          COLLAPSIBLE: 'Entertainment'
        },
        PM: {
          COLLAPSIBLE: 'Merchant Payment'
      },
        GCB: {
          COLLAPSIBLE: 'Card Management',
        }
      },
      AUTRE: {
        SECTION: '****',
        FP: {
          COLLAPSIBLE: 'Loyalty Program',
        },
        MT: {
          COLLAPSIBLE: 'Transactions',
        },
        MC: {
          COLLAPSIBLE: 'Consumption',
        },
        dashm: {
          COLLAPSIBLE: 'Merchant Dashboard',
        },
        moncompte: {
          COLLAPSIBLE: 'My Account',
        },
        trvr: {
          COLLAPSIBLE: 'Money Transfer',
        },
        his: {
          COLLAPSIBLE: 'History',
        },
        conso: {
          COLLAPSIBLE: 'Consumption',
        }
      },
      DOC: {
        SECTION: 'Documents',
      },
      FAQ: {
        SECTION: 'FAQ et Contact',
      }
    }
  }
};
